<template>
	<div>
		<AppDialog
				   v-for="dialog in Object.values(dialogs)"
				   :key="dialog.id"
				   v-bind="dialog.dialogOptions"
				   :modelValue="dialog.visible"
				   @update:modelValue="val => dialog.visible = val"
				   @closed="close(dialog.id)">
			<component
					   :is="dialog.contentComponent"
					   v-bind="dialog.props" />
		</AppDialog>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useDialog } from '@/composables/useDialog';
import AppDialog from '@/components/Dialog/Dialog.vue';

export default defineComponent({
	name: 'DialogHost',
	components: {
		AppDialog
	},
	setup() {
		const { dialogs, close } = useDialog();
		return { dialogs, close };
	}
});
</script>
